<template lang="pug">
    Error(:code="404" message="Page Not Found")
</template>

<script>
import Error from '@/components/Error'

export default {
    name: 'PageNotFound',
    components: { Error },
}
</script>

<style lang="sass" scoped></style>
